import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=fc3f0eac&scoped=true&"
import script from "./Part2.vue?vue&type=script&lang=js&"
export * from "./Part2.vue?vue&type=script&lang=js&"
import style0 from "./Part2.vue?vue&type=style&index=0&id=fc3f0eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3f0eac",
  null
  
)

export default component.exports